import React, { useState } from 'react';
import { TextBox } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import { eyeIcon, eyeSlashIcon } from '@progress/kendo-svg-icons';

const PasswordField = (props) => {
  const { maxDisplayLength = 20, value, ...data } = props;
  const [inputType, setInputType] = useState('password');
  const [iconName, setIconName] = React.useState(eyeIcon);
  const togglePasswordVisibility = () => {
    setInputType(inputType === 'password' ? 'text' : 'password');
    setIconName(iconName === eyeIcon ? eyeSlashIcon : eyeIcon);
  };
  const displayValue =
    inputType === 'password' && value?.length > maxDisplayLength
      ? `${value.substring(0, maxDisplayLength)}...`
      : value;
  return (
    <TextBox
      {...data}
      value={displayValue}
      type={inputType}
      suffix={() => (
        <Button
          svgIcon={iconName}
          onClick={togglePasswordVisibility}
          fillMode="flat"
        />
      )}
    />
  );
};
export default PasswordField;
